import { render, staticRenderFns } from "./page-notification-wizard.vue?vue&type=template&id=4bf5f420"
import script from "./page-notification-wizard.vue?vue&type=script&lang=js"
export * from "./page-notification-wizard.vue?vue&type=script&lang=js"
import style0 from "./page-notification-wizard.vue?vue&type=style&index=0&id=4bf5f420&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports